import {HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {environment} from '~local/environments/environment';


export const authTokenIntercept: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
    let request = req;

    let token = '';
    const savedCredentials = sessionStorage
        .getItem(environment.credentialsKey) || localStorage.getItem(environment.credentialsKey);

    if (savedCredentials) {
        token = JSON.parse(savedCredentials).token;
    }

    request = req.clone({
        setHeaders: {
            Authorization: token
        }
    });
    return next(request);
};
